exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".remote-readiness-all__title[data-v-37628878]{color:#303030;font-family:Lato;font-size:20px;font-weight:700;letter-spacing:0;line-height:28px}@media (max-width:768px){.remote-readiness-all__title[data-v-37628878]{font-size:14px;font-weight:700;letter-spacing:0;line-height:24px}}", ""]);

// exports
